import * as React from "react";
import { forwardRef } from "react";
const SvgOpen = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m17 10-4.764 3.92A.372.372 0 0 1 12 14a.372.372 0 0 1-.236-.08L7 10" }));
const ForwardRef = forwardRef(SvgOpen);
export { ForwardRef as ReactComponent };
